import type { SubCategory } from "@scott/ui-d2c/types";
import type React from "react";
import { BannerNav } from "./banner-nav";
import { CategoryTitle } from "./category-title";
import { useNavigationStore } from "./use-navigation-store";

// Navigation hierarchy constants
const NAV_LEVEL_FOURTH = 4;
const NAV_LEVEL_FIFTH = 5;

interface FourthPanelProps {
  isActive: boolean;
  data: SubCategory | null;
}

const FourthPanel: React.FC<FourthPanelProps> = ({ isActive, data }) => {
  const { setLevel, clearFromLevel, pushToDataLayer } = useNavigationStore();
  return (
    <div
      className={`fixed top-0 right-0 bottom-0 left-0 z-40 w-full overflow-hidden bg-nav-bg-secondary pt-6 pl-6 font-nav-paragraph font-nav-weight text-nav-color transition-transform duration-300 ease-in-out lg:z-10 lg:w-[372px] ${isActive ? "translate-x-16 lg:translate-x-[792px]" : "-translate-x-full"}`}
      id="fourth"
    >
      {data && (
        <>
          <div className="h-[88px]" />
          <div className="relative">
            <CategoryTitle
              link={data.link}
              linkClicked={() => {
                clearFromLevel(NAV_LEVEL_FOURTH);
                pushToDataLayer();
              }}
              linkName={data.linkName}
              title={data.title}
              titleEN={data.titleEN}
            />
          </div>
          <div className="mr-6 border-nav-gray border-b" />
          <div className="linkscontainer relative max-h-[calc(100vh-224px)] overflow-auto pr-6">
            <ul className="nav-links py-3">
              {data.children?.map((subCategory, index) => (
                <li
                  className={`m-0 cursor-pointer text-[16px] ${subCategory.entries ? "py-4" : "py-2"}`}
                  key={`fourth-subcategory-${subCategory.titleEN || index}`}
                >
                  <a
                    className={`navlinkstitle block hover:text-nav-hover ${subCategory.onSale ? "text-sale hover:text-salehover" : ""} ${subCategory.entries ? "" : "font-normal"}`}
                    href={subCategory.link}
                    onClick={() => {
                      setLevel(NAV_LEVEL_FOURTH, subCategory.titleEN, index);
                      pushToDataLayer();
                    }}
                  >
                    {subCategory.title}
                  </a>
                  {subCategory.entries && (
                    <ul className="py-3">
                      {subCategory.entries.map(
                        // @ts-expect-error not today
                        (entry: SubCategory, subIndex: number) => (
                          <li
                            className="m-0 cursor-pointer py-1.5 text-[14px]"
                            // @ts-expect-error not today
                            key={`fourth-entry-${entry.linkNameEN || subIndex}`}
                          >
                            <a
                              className={`block font-normal hover:text-nav-hover ${subCategory.onSale ? "text-sale hover:text-salehover" : ""}`}
                              href={entry.link}
                              onClick={() => {
                                setLevel(
                                  NAV_LEVEL_FOURTH,
                                  subCategory.titleEN,
                                  index
                                );
                                setLevel(
                                  NAV_LEVEL_FIFTH,
                                  // @ts-expect-error not today
                                  entry.linkNameEN,
                                  subIndex
                                );
                                pushToDataLayer();
                              }}
                            >
                              {entry.linkName}
                            </a>
                          </li>
                        )
                      )}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
            <BannerNav
              banners={data.entries || []}
              currentLevel={NAV_LEVEL_FOURTH}
            />
          </div>
        </>
      )}
    </div>
  );
};

export { FourthPanel };
